// extracted by mini-css-extract-plugin
export var heroImage = "_kc-1";
export var modal = "_kc-0";